import { Userpilot } from 'userpilot';

import Boards from '../../services/boards';
import User from '../../services/user';
import Plans from '../../services/plans';

const state = {
  user: null,
  owner: null,
  permissions: {},
  isStaff: false,
  isDev: false,
  accounts: null,
  tagboards: [],
};

const Permissions = [
  'producer',
  'tagboard_launch',
  'composer',
  'themes',
  'loaded_posts',
  'custom_fonts',
];

const updateMeta = (name, value) => {
  let el = document.querySelector(`meta[name=data-${name}]`);

  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', `data-${name}`);
    document.head.appendChild(el);
  }

  el.setAttribute('content', value);
};

const actions = {
  async getUserInfo(context) {
    const user = await User.getInfo();
    context.commit('SET_USER', user);

    // Initialize Userpilot and identify user
    if (user) {
      Userpilot.initialize(process.env.USERPILOT_TOKEN);
      Userpilot.identify(user.id, {
        email: user.profile.email,
        name: user.profile.displayName,
      });
    }

    return user;
  },

  async getAccounts(context) {
    const { user } = context.state;
    if (!user) { return; }

    const data = await Plans.getAccounts(user.id);
    context.commit('SET_USER_ACCOUNTS', data);
  },

  async getPermissions(context) {
    const { owner } = context.state;
    const permissions = await Plans.checkPermissions(owner, Permissions);
    context.commit('SET_PERMISSIONS', permissions);
  },

  async getTagboards(context) {
    const { owner } = context.state;
    const data = await Boards.getBoards(owner);
    context.commit('SET_TAGBOARDS', data);
  },

  setOwner(context, owner) {
    context.commit('SET_OWNER', +owner);
  },
};

const mutations = {
  /* eslint-disable no-shadow, no-param-reassign */

  SET_USER(state, user) {
    state.user = user;
    state.isStaff = user?.groups?.includes('staff');
    state.isDev = user?.groups?.includes('dev');

    // Set token metadata; still needed for some libs & requests.
    if (user?.token) {
      updateMeta('user-token', user.token);
    }
  },

  SET_USER_ACCOUNTS(state, payload) {
    state.accounts = payload;
  },

  SET_TAGBOARDS(state, payload) {
    state.tagboards = payload.results;
  },

  SET_OWNER(state, payload) {
    state.owner = payload;
  },

  SET_PERMISSIONS(state, permissions) {
    state.permissions = {
      ...state.permissions,
      ...permissions,
    };
  },
};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
};
